/**
 * This file was auto-generated by Fern from our API Definition.
 */
import * as core from "../../../../core";
import { BaseProperty } from "./BaseProperty";
export const StringListProperty = core.serialization.object({}).extend(BaseProperty);
